<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >

                    <div class='rows'>
                        <div class='row is-full'>
                            <b-field grouped >

                                <b-field label="Start Date">
                                    <b-datepicker
                                            :date-formatter="dateFormatterForDatePicker"
                                            v-model="date_selectedStart"
                                            placeholder="Click to select..."
                                            icon="calendar-today"
                                    >
                                    </b-datepicker>
                                    <b-tooltip label="Set Today" position="is-top">
                                        <p class="control">
                                            <b-button type="is-success" icon-left="close"  outlined  @click="loadCurrentDate(0)"/>
                                        </p>
                                    </b-tooltip>
                                </b-field>




                                <b-field label="Due Date">
                                    <b-datepicker
                                            :date-formatter="dateFormatterForDatePicker"
                                            v-model="date_selectedDue"
                                            placeholder="Click to select..."
                                            icon="calendar-today"
                                    >
                                    </b-datepicker>
                                    <b-tooltip label="Set Today" position="is-top">
                                        <p class="control">
                                            <b-button type="is-success" icon-left="close"  outlined  @click="loadCurrentDate(1)"/>
                                        </p>
                                    </b-tooltip>
                                </b-field>



                                <b-field label="#">
                                    <b-button type="is-success" icon-left="refresh" outlined @click="loadData">Refresh</b-button>
                                </b-field>


                            </b-field>
                        </div>
                    </div>





                </header>
                <section class="modal-card-body"  >
                    <!-- Content ... -->
                    <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                    <b-table
                            :data= "isEmpty ? []  : disableList"
                            bordered
                            striped
                            hoverable
                            paginated
                            :per-page="perPage"
                            :current-page.sync="currentPage"
                    >
                        <!--                        :loading="isTblLoading"-->

                        <b-table-column  label="No."  centered v-slot="props">
                            {{ props.row.no }}
                        </b-table-column>


                        <b-table-column  label="LAB No."  centered v-slot="props">
                            {{ props.row.idlab }}
                        </b-table-column>


                        <b-table-column  label="OPD No."  centered v-slot="props">
                            {{ props.row.idopd }}
                        </b-table-column>

                        <b-table-column  label="Pet Name"  centered v-slot="props">
                            {{ props.row.opd_name }}
                        </b-table-column>

                        <b-table-column  label="Owner Name"  centered v-slot="props">
                            {{ props.row.owner_name }}
                        </b-table-column>


                        <b-table-column  label="Order No."  centered v-slot="props">
                            {{ props.row.idlaborder }}
                        </b-table-column>


                        <b-table-column  label="DateTime Disabled"  centered v-slot="props">
                            {{ props.row.date_disabled }}  ( {{ props.row.time_disabled }} )
                        </b-table-column>


                        <b-table-column  label="Reason" width="300"  centered v-slot="props">
                            {{ props.row.lab_disable_reason }}
                        </b-table-column>


                        <b-table-column  label="User Disabled"  centered v-slot="props">
                            {{ props.row.user_disable }}
                        </b-table-column>



                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="table-search"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>

                    </b-table>

                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-danger"
                              icon-left="close"  @click="closeModal"   >
                        Close
                    </b-button>
                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    import dateFormatterForDatePicker from "../../../mixins/methods/dateFormatterForDatePicker";
    import findDiffDate from "../../../mixins/methods/findDiffDate";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios}  from '@/utils.js'
    import moment from "moment";
    import { mapState } from "vuex";

    export default {
        name: "ReportDisabled",

        mixins:[findDiffDate,dateFormatterForDatePicker],
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods : {
            loadData(){
                // console.log('loadDat')
                const daysDiff = this.findDiffDate(this.date_selectedStart,this.date_selectedDue)
                if(daysDiff>31 || daysDiff<0 ){
                    var alarmTxt =   ` `
                    if (daysDiff<0){
                        alarmTxt =   `start date less than due date `
                    }
                    if(daysDiff>31){
                        alarmTxt =   `date over 31 day `
                    }
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: ` Invalid date selected at  ${alarmTxt}  =>  user select at  ${daysDiff}  day`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }




                const vm = this
                const  datTo = {
                                  "date_selected":[moment(this.date_selectedStart).format("YYYY-MM-DD"), moment(this.date_selectedDue).format("YYYY-MM-DD")]
                               }
                this.isFullScreenSearching  = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdisablereport`,datTo ,getConfigAxios())
                    .then( (res) => {
                        vm.disableList = res.data
                        setTimeout(()=>{
                        vm.isFullScreenSearching  = false
                        },500)
                    })
                    .catch((error)=>{
                        // console.log(error)
                        vm.isFullScreenSearching  = false
                        vm.$buefy.toast.open({
                            duration: 500,
                            message:  `${error}`,
                            position: 'is-bottom',
                            type: 'is-warning'
                        })
                    })
            },


            loadCurrentDate(type_){
                const vm = this
                axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                    .then( response => {
                        if(type_ === 0){
                            vm.date_selectedStart = new Date(response.data.current_datetime)
                        }else if(type_ === 1){
                            vm.date_selectedDue = new Date(response.data.current_datetime)
                        }else {
                            vm.date_selectedStart = new Date(response.data.current_datetime)
                            vm.date_selectedDue = new Date(response.data.current_datetime)
                        }
                    })
                    .catch((error)=>{
                        // console.log(error)
                        vm.$buefy.toast.open({
                            duration: 500,
                            message:  `${error}`,
                            position: 'is-bottom',
                            type: 'is-warning'
                        })
                    })

            },
            closeModal(){
                this.isComponentModalActive  = false
            }
        },
        data(){
            return {
                disableList : [],
                isComponentModalActive : false,
                isFullScreenSearching  : false,
                isFullScreen: true,
                isEmpty : false,

                perPage : 50,
                currentPage : 1,

                date_selectedStart : null,
                date_selectedDue : null

            }
        }
    }
</script>

<style scoped>

</style>